import React, { Component } from "react";
import Close from "../../../../../Icons/Close";
import { styles } from "../../../../../ReactConst";
import { StyleRoot } from "radium";
import { withTranslation } from 'react-i18next';
class ModaleSuppressionInfoParent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      styleFadeIn: true,
    };
    this.confirmeDeleteInfoParent = this.confirmeDeleteInfoParent.bind(this);
  }

  closeModal = () => {
    this.setState({
      styleFadeIn: false,
    });
    setTimeout(() => {
      this.props.onCloseModaleSuppressionInfoParent();
    }, 400);
  };
  componentWillMount() {
    this.setState({ styleFadeIn: true });
  }
  confirmeDeleteInfoParent = () => {
    this.setState({ styleFadeIn: false });
    this.props.onSubmitSuppressionInfoParent();
  };
  render() {
    return (
      <StyleRoot>
        <div
          className="modal fade modal-skin show actif"
          id="modalDelete"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
          style={
            this.state.styleFadeIn === true ? styles.bounce : styles.bounce2
          }
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <form onSubmit={this.confirmeDeleteInfoParent}>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={this.closeModal}
                >
                  <Close className="img-fluid" alt="" />
                </button>
                <div className="modal-body">
                  <section>
                    <h5 className="modal-title">{this.props.t('fiche_enfant.delete_parent_info')}</h5>
                  </section>
                  <section>
                    <h5>{this.props.t('fiche_enfant.confirm_delete_parent_info')}</h5>
                  </section>
                  <p className="bottom-space"></p>
                  <section>
                    <div className="d-flex justify-content-center">
                      <button
                        type="submit"
                        className="btn-gradient btn-confirm"
                      >
                        <img
                          src="img/icon-check-white.svg"
                          class="img-fluid"
                          alt=""
                        />{" "}
                        {this.props.t('common.confirm')}
                      </button>
                    </div>
                  </section>
                </div>
              </form>
            </div>
          </div>
        </div>
      </StyleRoot>
    );
  }
}
export default withTranslation()(ModaleSuppressionInfoParent);
